import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import { BUSINESS } from '../lib/business';
import { buildWhatsappUrl } from '../lib/whatsapp';
import { eyebrow, h1, card } from '../lib/styles';

const waLink = buildWhatsappUrl(BUSINESS.whatsapp, 'Hola Zenya, me gustaría agendar una cita.');

const NOTAS = [
  'Cada servicio muestra su duración real, así que reserva el bloque completo.',
  'Si es tu primera vez en pestañas o faciales, agenda con 10 minutos extra para la valoración.',
  'Para cambios o cancelaciones, avísanos con al menos 4 horas de anticipación.',
];

const Booking = () => (
  <div style={{ padding: '5vw', maxWidth: 1100, margin: '0 auto' }}>
    <div style={{ maxWidth: '56ch' }}>
      <span style={eyebrow}>Agendar</span>
      <h1 style={h1}>Elige tu día y tu hora</h1>
      <p style={{ fontSize: 16, lineHeight: 1.75, color: 'var(--ink-600)', margin: '0 0 4vw' }}>
        Selecciona el servicio, la profesional y el horario que te acomode. Recibirás la confirmación por correo. Si
        prefieres preguntar antes, escríbenos por WhatsApp y te orientamos.
      </p>
    </div>

    <div style={{ ...card, overflow: 'hidden', width: '100%' }}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 10,
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 22px',
          borderBottom: '1px solid var(--ink-100)',
        }}
      >
        <span style={{ fontSize: 11, letterSpacing: '.18em', textTransform: 'uppercase', color: 'var(--ink-500)' }}>
          Reservas en línea · AgendaPro
        </span>
        <a
          href={BUSINESS.agendaproUrl}
          target="_blank"
          rel="noreferrer"
          style={{ fontSize: 12.5, color: 'var(--rose-700)', borderBottom: '1px solid var(--rose-200)' }}
        >
          Abrir en una pestaña nueva
        </a>
      </div>

      {BUSINESS.agendaproSrc ? (
        <iframe
          src={BUSINESS.agendaproSrc}
          title="Reservas Zenya — AgendaPro"
          loading="lazy"
          style={{ display: 'block', width: '100%', height: 820, border: 0 }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            minHeight: 400,
            background: 'var(--ink-50)',
            borderTop: '1px dashed var(--ink-300)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 14,
            textAlign: 'center',
            padding: 32,
          }}
        >
          <span style={{ color: 'var(--rose-600)' }}>
            <Calendar size={28} strokeWidth={1.5} />
          </span>
          <span style={{ fontSize: 10, letterSpacing: '.22em', textTransform: 'uppercase', color: 'var(--ink-400)' }}>
            Contenedor AgendaProBooking
          </span>
          <span style={{ fontSize: 14.5, lineHeight: 1.7, color: 'var(--ink-600)', maxWidth: '46ch' }}>
            Aquí se inserta el iframe de AgendaPro tal cual lo entrega la plataforma. El contenedor ya es responsivo y
            no genera scroll horizontal en ningún tamaño.
          </span>
          <span style={{ fontSize: 13, color: 'var(--ink-500)', maxWidth: '46ch' }}>
            Pega el src del iframe en la propiedad{' '}
            <strong style={{ color: 'var(--ink-700)', fontWeight: 400 }}>agendaproSrc</strong> para verlo funcionando
            dentro del sitio.
          </span>
        </div>
      )}
    </div>

    <div className="z-split-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 20, marginTop: '3vw' }}>
      <div style={{ background: 'var(--rose-50)', borderRadius: 'var(--radius-xl)', padding: 26 }}>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 400,
            fontSize: 24,
            color: 'var(--ink-900)',
            margin: '0 0 10px',
          }}
        >
          ¿No carga el calendario?
        </h2>
        <p style={{ fontSize: 14.5, lineHeight: 1.7, color: 'var(--ink-600)', margin: '0 0 18px' }}>
          Puedes reservar directamente en la página de AgendaPro de Zenya, o escribirnos y lo agendamos por ti.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          <a
            href={BUSINESS.agendaproUrl}
            target="_blank"
            rel="noreferrer"
            style={{
              background: 'var(--rose-700)',
              color: '#FFF',
              fontSize: 13,
              letterSpacing: '.06em',
              padding: '13px 22px',
              borderRadius: 'var(--radius-pill)',
            }}
          >
            Reservar en AgendaPro
          </a>
          <a
            href={waLink}
            target="_blank"
            rel="noreferrer"
            style={{
              border: '1px solid var(--rose-300)',
              color: 'var(--rose-700)',
              fontSize: 13,
              letterSpacing: '.06em',
              padding: '13px 22px',
              borderRadius: 'var(--radius-pill)',
            }}
          >
            Agendar por WhatsApp
          </a>
        </div>
      </div>
      <div style={{ ...card, padding: 26 }}>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 400,
            fontSize: 24,
            color: 'var(--ink-900)',
            margin: '0 0 14px',
          }}
        >
          Antes de reservar
        </h2>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 11 }}>
          {NOTAS.map((n) => (
            <li
              key={n}
              style={{
                display: 'flex',
                gap: 11,
                alignItems: 'flex-start',
                fontSize: 14.5,
                lineHeight: 1.65,
                color: 'var(--ink-600)',
              }}
            >
              <span
                style={{
                  width: 5,
                  height: 5,
                  borderRadius: '50%',
                  background: 'var(--rose-500)',
                  marginTop: 8,
                  flex: 'none',
                }}
              />
              {n}
            </li>
          ))}
        </ul>
        <Link
          to="/precios"
          style={{
            display: 'inline-block',
            marginTop: 18,
            fontSize: 13,
            letterSpacing: '.08em',
            textTransform: 'uppercase',
            color: 'var(--rose-700)',
          }}
        >
          Ver servicios y precios →
        </Link>
      </div>
    </div>
  </div>
);

export default Booking;
